module.exports = require('lodash').unset